import CommingSoonCountDown from "components/commingsoon-count-down";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { urlAssetsCustom } from "utils/common";
const TheButtonGuideJoin = () => {
  const navigate = useNavigate();

  const [scrollToElement, setScroolToElement] = useState(null);

  const handleScroll = (node) => {
    node.scrollIntoView({ behavior: "smooth" });
  };

  const location = useLocation();

  const handleScroolToElementAction = (elementId) => {
    if (location.pathname !== "/") {
      navigate("/");
      setScroolToElement(elementId);

      return;
    }
    handleScroll(document.getElementById(elementId));
  };

  useEffect(() => {
    !!scrollToElement && handleScroll(document.getElementById(scrollToElement));
    setScroolToElement(null);
  }, [scrollToElement]);

  return (
    <div className="btn-inline-center">
      <button
        type="submit"
        className="btn btn-warning btn-block"
        onClick={() => handleScroolToElementAction("guide_join")}
      >
        <a>hướng dẫn</a>
      </button>
      <button
        type="submit"
        className="btn btn-primary btn-block"
        onClick={() => handleScroolToElementAction("form_join")}
      >
        <a href="#form_join">Tham gia ngay</a>
      </button>
    </div>
  );
};

export default TheButtonGuideJoin;
